<template>
  <div class="main_content">
    <div class="title">
      1、品牌概述：
    </div>
    <div class="word">
      小鳗管家是四川辰鳗科技有限公司（简称“辰鳗科技”）旗下专注于商业楼宇能源数字化管理的品牌，重点涵盖能源管理系统、计量收费系统、动力储能回馈系统、暖通空调节能算法控制系统、智慧照明系统、空调分户计费系统等业务板块。
    </div>

    <div class="word">
      专业为商业综合体、产业园区、专业市场、公寓、写字楼等商业楼体提供数字化智能监测、智能收费、一站式全无线专业解决方案。
    </div>

    <div class="title">
      2、文化理念：
    </div>
    <div class="word">
      使命：每一度，我们在服务 愿景：致力于成为国内领先的综合能源服务商
      价值观：灵活坚定、开放包容、锐意进取、使命必达
    </div>

    <div class="title">
      3、品牌商标：
    </div>
    <div class="word">
      小鳗管家 申请/注册号：69830769、69828627
    </div>
    <div class="word">
      Smalleel
      申请/注册号：69825301、69829272、69826478
    </div>

    <div class="title">
      4、发展历程：
    </div>
    <div class="word">
      2020年6月 四川辰鳗科技有限公司成立div
    </div>

    <div class="word">
      2021年3月 项目经管系统正式上线
    </div>

    <div class="word">
      2021年7月 辰鳗智慧能源科技（天津）有限公司成立
    </div>

    <div class="word">
      2022年2月 获得PreA轮2000万元融资
    </div>

    <div class="word">
      2022年3月 浙江辰鳗能源设备制造有限公司成立
    </div>

    <div class="word">
      2022年6月起 集团经管系统正式上线
      项目能源管理系统正式上线集团能源管理系统正式上线 水表预付系统正式上线
    </div>

    <div class="word">
      2023年2月 动力储能回馈装置正式推出
    </div>

    <div class="word">
      2023年2月 获得5000万元融资
    </div>

    <div class="word">
      2023年3月 江苏辰鳗科技有限公司成立
    </div>

    <div class="word">
      2023年4月 暖通空调节能算法控制系统正式上线
    </div>
    <div class="title">
      5、品牌荣誉
    </div>
    <div class="word">
      小鳗管家荣获“「WISH CHINA」2022新能源先锋企业TOP50”
    </div>
    <div class="title">
      6、核心产品
    </div>
    <div class="word">
      能源管理系统：
      基于小鳗管家能耗监测模块、设备监控模块、业态分析模块，运维管理模块等，实现了能耗采集、数据统计、分项分析、异常诊断、需量分析、故障告警、报表分析等管理功能。
    </div>
    <div class="word">
      计量收费系统：
      基于预付费智能终端，实现电能消耗的在线监测和管理，具备网络在线充值，低余额报警、欠费断电等管理手段，并支持智能水表的接入和计费管理，有效解决抄表难、收费难的问题。
    </div>
    <div class="word">
      动力储能回馈系统：
      采用电梯专用高性能回馈式制动单元。升降电梯在使用电梯回馈节能产品后，能有效的将电池中储存的直流电能转换成交流电能回送到电网，节电率达20%-30%。
    </div>
    <div class="word">
      暖通空调节能算法控制系统： 采用低功耗LORA
      无线通讯和数据采集专利技术，基于云端AI
      算法和大数据处理技术，实现中央空调集控系统的最轻量化部署，实现能效提升、电力需求侧响应和智能运维，帮助企业节能、降本、增效。
    </div>
    <div class="word">
      智慧照明系统：通过使用微波雷达感应灯替换现有照明灯具，实现照明系统的按需供给能耗、无感节能，帮助项目大幅度降低能源费用支出，提升管理效率。
      空调分户计费系统：通过采集空调主机的工作状态、未端设备的运行状态和运行时间等信息，并基于时间段划分和费率设定，实现不同用户在不同时间段内的空调用量准确计量和费用计算。
    </div>

    <div class="title">
      5、专利信息：
    </div>
    <div class="word">
      一种带有能耗异常告警的智能电表 CN217587346U 实用新型
      一种带有防窃电功能的智能电表 CN217587359U 实用新型
    </div>
    <div class="title">
      6、软件著作权信息：
    </div>
    <div class="word">
      小鳗智能设备远程物联信息化管理软件 2022SR0665807
    </div>
    <div class="word">
      小鳗智能设备实时能耗监测管控平台 2022SR0667124
    </div>

    <div class="word">
      小鳗智能设备能耗数据在线监测预警分析系统 2022SR0654591
    </div>

    <div class="word">
      小鳗智能设备故障预警管理软件 2022SR0654590
    </div>

    <div class="word">
      小鳗智能设备终端信息交互控制管理系统 2022SR0654587
    </div>

    <div class="word">
      小鳗分润系统2022SR0569855
    </div>

    <div class="word">
      小鳗开放平台系统 2022SR0569892
    </div>

    <div class="word">
      小鳗智能设备定时控制系统 2022SR0569759
    </div>

    <div class="word">
      小鳗费用管理系统 2022SR0569891
    </div>

    <div class="word">
      小鳗智能设备数据监控采集系统 2022SR0557884
    </div>

    <div class="word">
      小鳗管家收费智能云平台 2022SR0530321
    </div>

    <div class="word">
      小鳗平台管理系统 2022SR0530319
    </div>

    <div class="word">
      小鳗企业管理系统 2022SR0530322
    </div>

    <div class="word">
      小鳗商户系统 2022SR0525197
    </div>

    <div class="word">
      小鳗物业系统 2022SR0529134
    </div>
    <div class="title">
      8、质量管理证书：
    </div>
    <div class="word">
      质量管理体系认证证书 41922Q00187-04R0S 环境管理体系认证证书
    </div>
    <div class="word" style="padding-bottom:50px">
      41922E00115-04R0S 职业健康安全管理体系认证证书 41922S00115-04R0S
    </div>
  </div>
</template>

<script>
export default {
  name: "news",

  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.main_content {
  text-align: left;
  .title {
    font-size: 18px;
    font-weight: 600;
    margin: 10px 0;
  }
  .word {
    font-size: 16px;
    line-height: 32px;
    text-indent: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/secret.vue